import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from 'src/app/common/constants/api-url.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionService {

  constructor( private http: HttpClient ) {

  }

  getTermAndCondition(type:string): Observable<any> {
    return this.http.get(ApiConstants.GET_POLICY(type))
  }


}
